import storageService from '../services/storage.service';

export const USER_PLANS = {
    FREE: 'free',
    STARTER: 'starter',
    ADVANCED: 'advanced',
    CUSTOM: 'custom',
} as const;

export const useUserPlan = () => {
    const plan = storageService.get('userPlan') || USER_PLANS.FREE;
    const LabelBuilder = storageService.get('isLabelBuilder');
    const userCount = Number(storageService.get('userCount') || 0);

    const isNotFreeAndStarter = plan !== USER_PLANS.FREE && plan !== USER_PLANS.STARTER;
    const isFreeOrStarter = plan === USER_PLANS.FREE || plan === USER_PLANS.STARTER;

    const isFreeStarterOrAdvanced = [
        USER_PLANS.FREE,
        USER_PLANS.STARTER,
        USER_PLANS.ADVANCED,
    ].includes(plan);

    const isLabelBuilderUser = Boolean(LabelBuilder);



    return {
        plan,
        isFree: plan === USER_PLANS.FREE,
        isStarter: plan === USER_PLANS.STARTER,
        isAdvanced: plan === USER_PLANS.ADVANCED,
        isCustom: plan === USER_PLANS.CUSTOM,
        isNotFreeAndStarter,
        isFreeOrStarter,
        isFreeStarterOrAdvanced,
        isLabelBuilderUser,
        userCount
    };
};
